<template>
    <v-navigation-drawer
        v-model="NavDrawer.isShowing"
        app
        fixed
        clipped
    >
        <v-list dense>
            <template v-for="(item,i) in Insights.nav.TOC.items">
                <v-subheader
                    v-if="i === 0"
                    :key="item.PathKey"
                >
                    <span class="font-weight-light text-upper">Content</span>
                </v-subheader>
                <v-divider :key="item.PathKey"></v-divider>
                <v-list-tile
                    :key="item.PathKey"
                    active-class="active"
                    :class="{active: item.TOCKey === Insights.nav.TOC.active}"
                    @click="onTOCSelect(item.Path)"
                >
                        <v-list-tile-content>
                            <v-list-tile-title><span class="subheading font-weight-light">{{ item.Title }}</span></v-list-tile-title>
                        </v-list-tile-content>
                </v-list-tile>
                <v-divider v-if="i === Insights.nav.TOC.items.length-1" :key="item.PathKey"></v-divider>
            </template>
        </v-list>
    </v-navigation-drawer>  
</template>

<script>
import Insights from '../models/Insights'
import NavDrawer from '../models/App.NavDrawer'

export default {
    data(){
        return {
            NavDrawer,
            Insights
        }
    },
    methods:{
        onTOCSelect(path){
            this.$router.push(path);
        }
    }
}
</script>

<style lang="scss" scoped>
.text-upper{
    text-transform: uppercase
}
.active{
    background-color: var(--v-accent-darken3);
    color:var(--v-secondary-lighten4);
}
</style>
